// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"f6bb84c1","750":"f7082bc2","762":"3dedc2d5","977":"2caed02d"}[chunkId] + ".chunk.js";
};